import React, {useEffect, useRef, useState, useStateWithLabel} from 'react'
import t from 'helpers/I18n'

import PropTypes from 'prop-types'
import BaseParagraph from "../../base-components/base-paragraph";
import BaseButton from "../../base-components/base-button";
import StepsLoader from "../steps-loader";
import InputFieldCountry from '../../base-components/base-input-country';
import InputField from '../../base-components/base-input';

import StepFooterAction from "../../base-components/step-footer-action";
import countriesData from 'assets/data/country-data.json'

const EnterpriseCountry = ({ _step_service, error, step_ID, step_URL, next_step, setDataToContext, getDataFromContext }) => {
    const form = useRef()
    const name = "enterprise_activity_country"
    const data = getDataFromContext(step_ID)
    const initialInputData = data && data[name] && data[name] !== "" ? data[name] : ""
    const initialSelectedNationalityArray = {}
    let default_step_form = [{
        type: "country",
        id: "birth_country-0",
        useDefault: false
    }]
    const lang = localStorage.getItem("language")

    const InitSelectedNat = ()=> {
        if (data?.enterprise_activity_country && data?.enterprise_activity_country !== "") {
            if (data.internal_entreprise_country_name) {
                Object.keys(data.internal_entreprise_country_name).forEach(name => {
                    const value = data.internal_entreprise_country_name[name]
                    initialSelectedNationalityArray[name] = {callingCode: value.callingCode , code: value.code, name: value.name}
               })
            }
        }
    }
    InitSelectedNat()
  
    const [inputData, setInputData] = useStateWithLabel(initialInputData, 'inputData')
    const [nextTick, setNextTick] = useStateWithLabel(false, "nextTick")
    const [fullNationalitySlection, setFullNationalitySlection] = useStateWithLabel(false, "fullNationalitySlection")
    const [isLoading, setIsLoading] = useStateWithLabel(false, "is loading")
    const [selectedNationalityArray, setSelectedNationalityArray] = useStateWithLabel(initialSelectedNationalityArray, "selectedNationalityArray")
    const [exclude, setExclude] = useStateWithLabel([], "excluded country") 
    const [isValid, setIsValid] = useStateWithLabel(false, "isvalid")
    const [isvalidCountry, setIsValidCountry] = useStateWithLabel(false, "isvalidCountry")


    const [countriesFULL] = useState(countriesData.map(ctr => ({
        name: ctr.translations[lang.toLocaleLowerCase()],
        callingCode: ctr.callingCodes[0],
        code: ctr.altSpellings[0],
        translation: {
            de: ctr.translations.de,
            fr: ctr.translations.fr,
            nl: ctr.translations.nl
        }
    })))
    const BE = countriesFULL.find(ct => {
        return ct.code === "BE"
    })
    const defaultCounty=  {
        country: BE.name,
        code: BE.code,
        callingCode: BE.callingCode
    }

    const defaultCOuntryArr = [{
        type: "country",
        id: "birth_country",
        defaultCounty
    }]

    const initDefaultStepForm = () => {
        if (data ) {
            if (data?.internal_entreprise_country_name && Object.keys(data?.internal_entreprise_country_name).length > 0) {
                default_step_form = []
                for (const [key, value] of Object.entries(data?.internal_entreprise_country_name)) {
                    if (value.code !== "BE") {
                         default_step_form.push({
                    type: "country",
                    id: key,
                    defaultCounty: {
                        country: value.name,
                        code: value.code,
                        callingCode: value.callingCode
                    }
                })
                    }
               
            }
            } else {
            default_step_form = []
        } 
        } 
    }
    initDefaultStepForm()

    const [nationalityArr, setNationalityArr] = useStateWithLabel(default_step_form, "nationalityArr")

    useEffect(() => {
        setInputData(Object.values(selectedNationalityArray).map(nt => (nt.code)).join(";"))
        nationalityArr.length > 1 && setFullNationalitySlection(true)
        const __exclude = Object.values(selectedNationalityArray).map(code => code.code)
        setExclude(__exclude)
    }, [selectedNationalityArray])

    useEffect(() => {
        // if (inputData !== "" && initialInputData !== "") {
        //     setInputData( initialInputData )   
        // }
        setIsValid(nationalityArr.length !== inputData.split(';').length)
    }, [inputData])

    useEffect(() => {
        if (nextTick) {
        _step_service({ step_ID, setIsLoading, next_step })
      }
    }, [nextTick])

    useEffect(() => {
        if (window.PageBus) {
            window.PageBus.publish("analyticsServices", {
                pageID: "onboarding",
                stepSeq: "3",
                stepName: "pro info:country of your activity",
                flowType: "sales",
                flowName: "onboarding",
                productName: "onboarding",
                trackMethod: "flow"
             });
        }
     }, [])
    
    const getInputValue = (name, value) => {
        if (value) {
            setSelectedNationalityArray({ ...selectedNationalityArray, [name]: {callingCode: value.callingCode , code: value.code, name: value.country}})
        }
    }

    const getOptIn = (value) => {
           console.log("checkboxx value", value)
            setIsValidCountry(value)
    }

    const addNationnality = () => {
        const length = nationalityArr.length + 1
        nationalityArr.push({
            type: "country",
            id: "birth_country-" + length,
            useDefault: false
        })
        nationalityArr.length > 1 && setFullNationalitySlection(true)
        setIsValid(nationalityArr.length !== inputData.split(';').length)
        setNationalityArr([...nationalityArr])
    }

    const removeNationality = (item) => {
        const id = item.id
        const code = selectedNationalityArray[id]?.code
        
        setInputData(inputData => inputData.split(";").filter(ar => ar !== code).join(";"))
        const excl = exclude.filter(ar => ar !== code)
        setExclude(excl)
        
        delete selectedNationalityArray[id]
        setSelectedNationalityArray(selectedNationalityArray)

        const newArr = nationalityArr.filter(itm => itm.id !== id)
        setNationalityArr([...newArr])
        newArr.length < 2 && setFullNationalitySlection(false)
        setIsValid(newArr.length !== inputData.split(';').length)
    }

    const action = () => {
        if (inputData !== "") {
            setDataToContext(step_ID, step_URL, "enterprise_activity_country", inputData)
            setDataToContext(step_ID, step_URL, "internal_entreprise_country_name", JSON.stringify(selectedNationalityArray))
        }
        setNextTick(true)
    }

    return (
        <>
            <StepsLoader loading={isLoading}>
                 <form ref={form}>
                    <BaseParagraph>
                        <h3>{t('pro_infos.pro_info_country_of_your_activity.title')}</h3>
                        <p>{t('pro_infos.pro_info_country_of_your_activity.text')}</p>

                        {defaultCOuntryArr.map(input => (
                            <div
                                className="nationnality-country-wrapper"
                                key={input.id}
                            >
                                {/* {
                                    nationalityArr.length > 1 && <div
                                    className="nationnality-country-wrapper__delette"
                                    onClick={() => removeNationality(input)}>×</div>
                                } */}
                                
                                 <InputFieldCountry
                                    label={t('pro_infos.pro_info_country_of_your_activity.label_default')}
                                    name={input.id}
                                    getInputValue={getInputValue}
                                    error={error}
                                    type={input.type}
                                    exclude={exclude}
                                    value={input.defaultCounty}
                                    useDefault={input.useDefault}
                                    disabled={true}
                                    />
                            </div>
                        ))}
                        {nationalityArr.map(input => (
                            <div
                                className="nationnality-country-wrapper"
                                key={input.id}
                            >
                                {
                                    nationalityArr.length > 0 && <div
                                    className="nationnality-country-wrapper__delette"
                                    onClick={() => removeNationality(input)}>×</div>
                                }
                                
                                 <InputFieldCountry
                                    label={t('pro_infos.pro_info_country_of_your_activity.label_otther')}
                                    name={input.id}
                                    getInputValue={getInputValue}
                                    error={error}
                                    type={input.type}
                                    exclude={exclude}
                                    value={input.defaultCounty}
                                    useDefault={input.useDefault}
                                    />
                            </div>
                        ))}
                    </BaseParagraph>
                </form>
                
                {/* { nationalityArr.length === 0 && <BaseButton blue nokb caption={t('personal_infos.Personal_info_nationality.add_country')} action={addNationnality} />} */}
                { !fullNationalitySlection && <BaseButton blue nokb caption={t('personal_infos.Personal_info_nationality.add_country')} action={addNationnality} />}
                <br />
                <InputField
                    type={"checkbox"}
                    id={"EnterpriseCountryVerify"}
                    error={[]}
                    name={"checkbox"}
                    label={"test"}
                    checkboxlabelbold={false}
                    checkboxLabel={t('pro_infos.pro_info_country_of_your_activity.checkbox_label')}
                    emitCheckbox={getOptIn}/>
                
                <StepFooterAction caption={t('general.continue')}  action={action} link={next_step} disabled={!isvalidCountry} />
            </StepsLoader>
        </>
    )
}

EnterpriseCountry.propTypes = {
    name: PropTypes.string
}

EnterpriseCountry.defaultProps = {
    name: "email-step"
}


export default EnterpriseCountry